import { setIsSessionExpiredAction } from '@Core/Communication/GlobalStore/Reducers/authentication/reducer'
import { getAuth, onIdTokenChanged } from 'firebase/auth'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const ACCESS_TOKEN_KEY = '@ofc:accessToken'

/** Fired on window whenever the Firebase SDK hands out a new ID token. */
export const ID_TOKEN_EVENT = 'ofc:id-token'

interface SessionStorage {
    setItem(key: string, value: string): void
    removeItem(key: string): void
}

/**
 * Keeps the stored token in step with the Firebase session: the SDK refreshes
 * the ID token before it expires (about every hour) and this writes each new
 * one, so an active user is never dropped to the session-expired screen
 * (FR-005). When the session ends — sign-out, revoked or disabled account —
 * the screen is shown.
 */
export const useSession = (storage: SessionStorage) => {
    const dispatch = useDispatch()

    useEffect(() => {
        const unsubscribe = onIdTokenChanged(getAuth(), async (user) => {
            if (!user) {
                storage.removeItem(ACCESS_TOKEN_KEY)
                dispatch(setIsSessionExpiredAction(true))
                return
            }
            try {
                const token = await user.getIdToken()
                storage.setItem(ACCESS_TOKEN_KEY, token)
                dispatch(setIsSessionExpiredAction(false))
                window.dispatchEvent(new CustomEvent(ID_TOKEN_EVENT, { detail: token }))
            } catch (error) {
                console.error(error)
                dispatch(setIsSessionExpiredAction(true))
            }
        })
        return unsubscribe
    }, [])
}
